import currency from 'currency.js';
import { CurrencyJSKey } from '@/symbols';

import type { App } from 'vue'

export default {
    install: (app: App) => {
        app.config.globalProperties.$currency = currency
        app.provide(CurrencyJSKey, currency);
    }
}

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $currency: any
    }
}